export default {
  explosiveness: 'explosiveness',
  competitiveness: 'competitiveness',
  toughness: 'toughness',
  agility: 'agility',
  focus: 'focus',
  power: 'power',
}